import { ListType } from "common/list";
import { SearchService } from "./SearchService";
import { AlgoliaSearchService } from "common/search/services/AlgoliaSearchService";
import { configFor } from "./services/SearchConfig";
import { InventorySearchService } from "common/search/services/InventorySearchService";
import { LogisticsSearchConfig } from "./services/LogisticsSearchConfig";
import { memoize } from "lodash";
import { OrderIngestErrorService } from "./services/OrderIngestErrorService";
import { OrderSearchService } from "./services/OrderSearchService";
import { ParcelSearchService } from "common/search/services/ParcelSearchService";
import { PrepSearchService } from "./services/PrepSearchService";
import { ClaimUploadsSearchService } from "./services/ClaimUploadsSearchService";
import { BundleOpenSearchService } from "./services/BundleOpenSearchService";
import { ReserveStorageOutboundsSearchService } from "./services/ReserveStorageOutboundsSearchService";
import { InboundsSearchService } from "./services/InboundsSearchService";
import { CarrierSearchService } from "./services/CarrierSearchService";
import { NonComplianceSearchService } from "./services/NonComplianceSearchService";
import { JobRunsSearchService } from "common/search/services/JobRunsSearchService";
import { ReturnOrdersSearchService } from "./services/ReturnOrdersSearchService";
import { ReturnsPackagesSearchService } from "./services/ReturnsPackagesSearchService";

export const searchServiceFor = memoize((listType: ListType): SearchService => {
  switch (listType) {
    case ListType.Inventory:
    case ListType.Bundle:
      return new AlgoliaSearchService(configFor(listType));
    case ListType.BundleV2:
      return new BundleOpenSearchService(configFor(listType) as LogisticsSearchConfig);
    case ListType.InventoryV2:
      return new InventorySearchService(configFor(listType) as LogisticsSearchConfig);
    case ListType.Parcel:
      return new ParcelSearchService(configFor(listType) as LogisticsSearchConfig);
    case ListType.Prep:
      return new PrepSearchService(configFor(listType) as LogisticsSearchConfig);
    case ListType.ClaimUploads:
      return new ClaimUploadsSearchService(configFor(listType) as LogisticsSearchConfig);
    case ListType.ReserveStorageOutbounds:
      return new ReserveStorageOutboundsSearchService(configFor(listType) as LogisticsSearchConfig);
    case ListType.InboundListV2:
      return new InboundsSearchService(configFor(listType) as LogisticsSearchConfig);
    case ListType.Carriers:
      return new CarrierSearchService(configFor(listType) as LogisticsSearchConfig);
    case ListType.Orders:
      return new OrderSearchService(configFor(listType) as LogisticsSearchConfig);
    case ListType.OrderIngestErrors:
      return new OrderIngestErrorService(configFor(listType) as LogisticsSearchConfig);
    case ListType.NonCompliance:
      return new NonComplianceSearchService(configFor(listType) as LogisticsSearchConfig);
    case ListType.JobRuns:
      return new JobRunsSearchService(configFor(listType) as LogisticsSearchConfig);
    case ListType.ReturnOrders:
      return new ReturnOrdersSearchService(configFor(listType) as LogisticsSearchConfig);
    case ListType.ReturnsPackages:
      return new ReturnsPackagesSearchService(configFor(listType) as LogisticsSearchConfig);
    case ListType.Inbounds:
    default:
      return new AlgoliaSearchService(configFor(listType));
  }
});
